import { createAction, handleActions } from 'redux-actions'
import { get } from 'lodash'

const openTimesheetPostingModal = createAction('MODALS/TIMESHEET/OPEN_TIMESHEET_POSTING_MODAL')
const closeTimesheetPostingModal = createAction('MODALS/TIMESHEET/CLOSE_TIMESHEET_POSTING_MODAL')

const defaultState = {
  show: false,
  id: null,
}

const reducer = handleActions(
  {
    [openTimesheetPostingModal]: (state, action) => ({
      ...state,
      show: true,
      id: get(action, 'payload.id', null),
    }),
    [closeTimesheetPostingModal]: () => defaultState,
  },
  defaultState,
)

export { openTimesheetPostingModal, closeTimesheetPostingModal, reducer }
